import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-[#faf6f0] text-gray-900 py-20 px-4" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-center mb-10 uppercase tracking-tight text-[#2a1f14]" data-id="element-157">
          Si tu mente nunca se detiene, no estás solo
        </h2>

        <div className="font-opensans text-xl md:text-2xl space-y-6 text-gray-800 leading-relaxed" data-id="element-158">
          <p className="text-center" data-id="element-159">
            Muchas personas viven con la mente en constante ruido.
          </p>
          <p className="text-center font-semibold" data-id="element-160">
            Pensando demasiado. Analizando todo. Preocupándose por situaciones
            que todavía no pasaron.
          </p>

          <p className="pt-8 pb-4 font-bold text-2xl text-center" data-id="element-161">
            Tal vez te pasa algo de esto:
          </p>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-200 max-w-3xl mx-auto" data-id="element-162">
            <ul className="space-y-4" data-id="element-163">
              {['Te cuesta desconectar la mente', 'Analizas conversaciones del pasado una y otra vez', 'Te preocupas demasiado por el futuro', 'Sientes tensión mental constante', 'Tu mente no descansa ni cuando intentas relajarte'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-164">
                  <XCircleIcon className="w-8 h-8 text-[#b5634b] flex-shrink-0 mt-1" data-id="element-165" />
                  <span className="font-semibold text-xl" data-id="element-166">{item}</span>
                </li>)}
            </ul>
          </div>

          <p className="text-center pt-8" data-id="element-167">Y aunque intentes distraerte…</p>

          <p className="text-center text-3xl md:text-4xl font-oswald font-bold mt-4" data-id="element-168">
            <span className="text-highlight bg-[#FAF6F0]" data-id="element-169">
              Tu mente vuelve al mismo lugar.
            </span>
          </p>
        </div>
      </div>
    </section>;
}